/* eslint-disable import/no-cycle */
import React from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ErrorHelpText } from 'components/forms/components/HelpText'
import { StyledLabel } from 'components/styled-input-label'
import e2eClasses from 'helpers/automation'

const Wrapper = styled.div``

export const TextAreaStyled = styled.textarea.attrs(({ maxLength, rows }) => ({
  className: e2eClasses('corporate.textArea'),
  maxLength,
  rows
}))`
  width: 100%;
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.colors.grayLight};
  color: ${({ theme }) => theme.colors.blueDark};
  padding: 14px;
  outline: 0;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  resize: none;
  ${({ theme, error }) => (error ? `border-color: ${theme.colors.red};` : '')};
  &:focus {
    border-color: ${({ theme }) => theme.colors.blue};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.doveGray};
  }
`

export const WrapperMessage = styled.div`
  display: flex;
`

export const Count = styled.p`
  width: 100%;
  color: ${({ theme }) => theme.colors.blueDark};
  padding: 0 6px 0 0;
  margin: 8px 0 0;
  opacity: 0.8;
  text-align: right;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
`

const TextArea = ({
  placeholder,
  labelFontSize,
  label,
  value = '',
  maxLength = null,
  error = null,
  pluralKey,
  singularKey,
  ...rest
}) => {
  const { t } = useTranslation()
  const remainingCharacter =
    Math.max(maxLength, 0) > 0 && maxLength - (value || '').length >= 0
      ? maxLength - (value || '').length
      : 0

  return (
    <Wrapper>
      {label && (
        <StyledLabel e2eClass={e2eClasses('corporate.observations')} fontSize={labelFontSize}>
          {label}
        </StyledLabel>
      )}
      <TextAreaStyled error={error} placeholder={placeholder} {...rest} />
      <WrapperMessage>
        {error && <ErrorHelpText message={error} />}
        {Math.max(maxLength, 0) > 0 && (
          <Count>
            {remainingCharacter > 1
              ? t(pluralKey, { value: remainingCharacter })
              : t(singularKey, { value: remainingCharacter })}
          </Count>
        )}
      </WrapperMessage>
    </Wrapper>
  )
}

export default TextArea
